import I18n from "../../I18n";
import jsesc from "jsesc";
import { parseFilter } from "colbi_web_ui/lib/utils";
import { SovosBox, SovosButton, SovosButtonsGroup, SovosDrawerHeader } from "mosaic-react";
import { Close } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { useTheme } from "mosaic-react/styles";

export const handleDownloadMultipleFiles = (props, pushNotification) => {
    const { pushDialog, i18n, downloadFiles, selectedFiles } = props;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Download Files`, {
        title: i18n`Do you want to download the file${selectedFiles.length > 1 && `s`} ?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            try {
                downloadFiles({ files: selectedFiles }, pushDialog, i18n);
            } catch (err) {
                pushNotification({
                    open: true,
                    message: i18n`Something went wrong!`,
                    type: "error",
                    timeout: "short",
                });
            }
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Downloaded selected file(s)!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleReprocessFile = (props, pushNotification) => {
    const { pushDialog, i18n, reprocessFiles, params, selectedFiles } = props;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Reprocess Files`, {
        title: i18n`Do you want to reprocess the file${selectedFiles.length > 1 && `s`}?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            reprocessFiles({
                files: selectedFiles.map((i) => parseInt(i.id)),
                projectId: params.projectId,
                fiscalYear: params.fiscalYear || "",
            })
                .then((res) => res && window.location.reload())
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Reprocessing selected file(s)!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleDeleteFilePermanently = (props, pushNotification) => {
    const { pushDialog, i18n, params, deleteFilePermanently, user, selectedFiles } = props;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Delete File Permanently`, {
        title: i18n`Are you sure you want to delete permanently the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            deleteFilePermanently({
                fiscalYear: params.fiscalYear || "",
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                userId: user.id,
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Deleting selected file(s)!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleDeleteGeneratorFileEntry = (props, pushNotification) => {
    const { pushDialog, i18n, selectedFiles, deleteGeneratorFileEntry } = props;
    const pluralOrSingularText =
        selectedFiles?.length > 0 && selectedFiles?.length >= 1 ? "entries" : "entry";
    const { fileId: fileIds } = (selectedFiles || [{}]).reduce(
        (acc, elem) => {
            const { fileId } = elem || {};
            acc.fileId.push(`${fileId}`);
            console.log(acc);
            return acc;
        },
        { fileId: [] },
    );
    pushDialog("ConfirmDialog", i18n`Delete File Permanently`, {
        title: i18n`Are you sure you want to delete permanently ${selectedFiles.length} entr${
            selectedFiles.length > 1 ? `ies` : `y`
        }?`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            deleteGeneratorFileEntry({
                generatorId: fileIds,
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: I18n.translate`Error deleting generation entries!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Deleting selected ${pluralOrSingularText}!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleMarkAsDeleted = (props, pushNotification) => {
    const { pushDialog, i18n, params, setDataFileStatus, selectedFiles } = props;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Mark as Delete`, {
        title: i18n`Are you sure you want to mark as delete the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setDataFileStatus({
                fiscalYear: params.fiscalYear,
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                status: "deleted",
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Marking file(s) as inactive!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleMarkAsActived = (props, pushNotification) => {
    const { pushDialog, i18n, params, setDataFileStatus, selectedFiles } = props;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Mark as Active`, {
        title: i18n`Are you sure you want to mark as active the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setDataFileStatus({
                fiscalYear: params.fiscalYear,
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                status: "imported",
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Marking file(s) as active!`,
                type: "confirmation",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleRequestMergeFromMergeCollisions = (props) => {
    const { pushDialog, i18n, params, reprocessRepository, user, pushNotification, reload } = props;
    pushDialog("ConfirmDialog", i18n`Process All`, {
        title: i18n`Merge Repo Metadata?`,
        promptText: i18n`Are you sure you want to process this action to all data in the repository`,
        confirmText: i18n`Merge Repo Metadata`,
    })
        .then(() => {
            const { filter } = params;
            const parsedFilter = parseFilter(filter);
            if (!filter || !parsedFilter || !parsedFilter?.length) {
                throw new Error("Missing filters, please select mandatory filters");
            }

            const dataToRequest = parsedFilter.reduce((acc, elem) => {
                if (elem?.column === "FiscalYear") {
                    acc["fiscalYear"] = elem.filters?.[0].value || null;
                }

                if (elem?.column === "Type") {
                    acc["fileType"] = elem.filters?.[0].value || null;
                }
                return acc;
            }, {});

            if (!dataToRequest?.fiscalYear || !dataToRequest?.fileType) {
                throw new Error("Missing filters, please select mandatory filters");
            }

            reprocessRepository({
                fiscalYear: dataToRequest.fiscalYear,
                projectId: params.projectId,
                fileType: dataToRequest.fileType,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.reprocess_repository) {
                        pushNotification({
                            open: true,
                            message: i18n`Starting reprocessing the repository`,
                            type: "confirmation",
                            timeout: "short",
                        });
                        reload && reload();
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        pushNotification({
                            open: true,
                            message: i18n`${jsesc(error)}`,
                            type: "error",
                            timeout: "short",
                        });
                    }
                })
                .catch(() => null);
        })
        .catch((error) => {
            error &&
                pushNotification({
                    open: true,
                    message: i18n`${jsesc(error)}`,
                    type: "error",
                    timeout: "short",
                });
            return;
        });
};

export const handleSendSalesInformationEmail = (props, pushNotification) => {
    const { pushDialog, i18n, selectedFiles, params, sendSalesInformationEmail } = props;

    const filesToSubmit = (
        selectedFiles.filter((x) => x.status === "imported" && x.internalStatus !== 1) || []
    ).map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
    }));

    if (selectedFiles.length === 0) return true;

    const filenames = filesToSubmit.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Submission Information`, {
        title: i18n`Are you sure you want to submit the file${filesToSubmit.length > 1 && `s`}?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            sendSalesInformationEmail(
                params.projectId,
                (filesToSubmit || []).map((i) => parseInt(i.id)),
            )
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => {
                    pushNotification({
                        open: true,
                        message: i18n`Something went wrong!`,
                        type: "error",
                        timeout: "short",
                    });
                });
        })
        .then(() => {
            pushNotification({
                open: true,
                message: i18n`Submitting selected file(s)!`,
                type: "info",
                timeout: "short",
            });
        })
        .catch(() => null);
};

export const handleFileSubmissionSubmission = (props) => {
    const { checkList, i18n, params, pushModal, pushNotification } = props;

    const selectedFiles = (checkList || []).reduce(
        (acc, elem) => {
            for (const key in acc) {
                if (key === "id") {
                    acc[key].push(parseInt(elem[key]));
                } else {
                    acc[key].push(elem[key]);
                }
            }
            return acc;
        },
        {
            id: [],
            name: [],
            hasHighFindings: [],
            period: [],
        },
    );

    const filenames = selectedFiles["name"];
    const fileIds = selectedFiles["id"];
    const filesWithProblems = (selectedFiles["hasHighFindings"] || [])
        .map((value, index) => {
            if (value) {
                return filenames[index];
            }
            return null;
        })
        .filter((r) => r);
    const filesPeriods = selectedFiles["period"];

    pushModal({
        title: i18n`SAF-T Files Submission`,
        data: {
            __typename: "DataFileSubmission",
            filenames,
            fileIds,
            projectId: params.projectId,
            filesWithProblems,
            filePeriods: filesPeriods,
        },
        args: {
            fiscalYear: params.fiscalYear,
            projectId: params.projectId,
        },
        view: "FileSubmissionForm",
        modalType: "center",
        customHeaderButton: RemoveDefaultButtons,
    })
        .then(() => {
            pushNotification({
                open: true,
                message: I18n.translate`Request successfully made`,
                type: "confirmation",
                timeout: "short",
                onClose: window.location.reload(),
            });
        })
        .catch(() => null);
};

//TODO create new file for this component
function RemoveDefaultButtons(props) {
    const { i18n } = useGlobalValue();
    const theme = useTheme();
    const { pop, id: modalID } = props || {};

    return (
        <SovosBox sx={{ width: "100%" }}>
            <SovosDrawerHeader title={i18n`You are submitting SAF-T Files`}>
                <SovosButtonsGroup align={"right"}>
                    <SovosButton
                        tooltipText={"Close"}
                        onClick={() => {
                            pop(modalID);
                        }}
                        color={theme.palette.text.primary}
                        children={<Close />}
                        variant={"text"}
                    />
                </SovosButtonsGroup>
            </SovosDrawerHeader>
        </SovosBox>
    );
}
